export default "https://static-website.miro.com/miro-site-lp-build-assets/_next/static/chunks/fonts/formular-regular-038ad836670f58232b9fb38f7de39660.eot";